/**
 * Where a campaign placement should take the shopper.
 *
 * Campaigns normally open their own curated product page. `external_link` is
 * the escape hatch (carried over from the old hero_banners.redirect_link) for
 * slides that should point somewhere else entirely.
 */
export const campaignHref = campaign => {
  if (!campaign) return '/products';
  return campaign.external_link || `/campaigns/${campaign.slug}`;
};

export const isExternalHref = href =>
  typeof href === 'string' && /^https?:\/\//i.test(href);

/**
 * Inline custom properties that let one component render legibly over very
 * different artwork without a code change.
 */
export const campaignStyleVars = campaign => ({
  '--campaign-scrim': String((campaign?.overlay_opacity ?? 35) / 100),
});

export const groupByPlacement = (campaigns = []) =>
  campaigns.reduce((acc, campaign) => {
    const key = campaign.placement || 'strip';
    (acc[key] = acc[key] || []).push(campaign);
    return acc;
  }, {});
